import { useQuery } from '@tanstack/react-query';
import { EnrollmentService } from '@/services/classServices/enrollmentService';

interface ClassEnrollmentCount {
  classId: string;
  enrolledCount: number;
  maxStudents: number;
}

export const useClassEnrollments = (classIds: string[]) => {
  return useQuery({
    queryKey: ['class-enrollments', classIds],
    queryFn: async (): Promise<Record<string, number>> => {
      const enrollmentCounts: Record<string, number> = {};
      
      // Fetch enrollments for each class
      await Promise.all(
        classIds.map(async (classId) => {
          const enrollments = await EnrollmentService.getClassEnrollments(classId);
          // Count only active enrollments
          enrollmentCounts[classId] = enrollments.filter(
            enrollment => enrollment.status === 'active'
          ).length;
        })
      );
      
      return enrollmentCounts;
    },
    enabled: classIds.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
};